const projects = [
    {
        name: 'electronic',
        title: 'Electronic and Optoelectronic Devices based on Low-Dimensional Materials',
        images:  [
            {
                name: 'vacuum-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/Picture2.jpg',
                title: 'High Vacuum In-situ Growth and Characterization System',
            },
            {
                name: 'laser-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/Picture4-e1581375587660.jpg',
                title: 'Ultra-fast Laser System',
            },
        ],
        content: [
            `
            The ultra-thinness and flexibility endue the low-dimensional materials the great advantages in electronics and optoelectronics. The flexibility and stability make them superb for wearable and implantable devices with the potentials in biological, medical, and environmental applications, as well as consumer electronics. The ultra-thinness further pushes the application of the low-dimensional materials to the quantum limit. The atomic-level thickness facilitates strong coupling with the optical evanescent wave, make the low-dimensional material the ideal platform for the application of near-field optics, photonics, and optoelectronics. Our lab is aiming to fully explore these potentials to further advance the development of modern electronics and optoelectronics for both fundamental research and actual applications. 
            `,
        ]
    },
    {
        name: 'surface',
        title: 'Surface/Interfacial Science and Engineering of Quantum Materials',
        images:  [
            {
                name: 'vacuum-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/c22dcaa7164cfbaeaa55527d6c28f72-e1581398905758.jpg',
            },
            {
                name: 'laser-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/92e630705c2a5d7fdd266d8e5609776-e1581399042504.jpg',
            },
            {
                name: 'laser-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/Picture3.jpg',
            },
            {
                name: 'laser-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/Picture1-e1581399422201.jpg',
            },
        ],
        content: [
            `
            The emerging quantum materials enable a bottom-up strategy for complex system design and engineering with rich physics properties and significant potentials in quantum computing and sensing. The surfaces and interfaces play an essential role in determining the interaction among the building blocks and the functions of the system. Realizing the importance of the surfaces and interfaces, Lei groups is making great efforts in investigating the nature and controlling methods of them, in order to tailor the properties of these quantum materials for improved performances. Our methods include physical adatom deposition, chemical treatment, epitaxial growth, etc. Supported by our state-of-the-art instruments, we are able to determine the effects of the surface/interfacial states on the lattice structure, photon response, lateral transport, quantum tunneling and so forth. 
            `,
        ]
    },
    {
        name: 'advanced',
        title: 'Advanced Manufacturing of Functional Ceramics and Soft Matters',
        images:  [
            {
                name: 'vacuum-system',
                primaryPic: 'https://cpb-us-w2.wpmucdn.com/sites.gsu.edu/dist/a/14938/files/2020/02/Picture1-e1581374156200.png',
            },
        ],
        content: [
            `
            The description will be added soon.
            `,
        ]
    },
    
];

export default projects;